import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalComponent } from 'src/app/global/global.component';

@Component({
  selector: 'app-page-not-match',
  templateUrl: './page-not-match.component.html',
  styleUrls: ['./page-not-match.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PageNotMatchComponent {

  router: Router;

  constructor(router: Router, public global: GlobalComponent) {
    this.global.checkforlogout();
    this.router = router;
  }

  searchResult(): void {
    this.router.navigate(['/search']);
  }

  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
  }

}
